$(document).ready(function () {
  $('.isotope').waitForImages().done(function () {
    var isotope = $('.isotope'),
      itemElement = '.grid-item',
      filters = $('.isotope-filters');
    if (isotope != null) {
      isotope.isotope({
        resizable: true,
        itemSelector: itemElement,
        masonry: {
          gutterWidth: 10
        }
      });
      isotope.isotope('on', 'arrangeComplete', initGallery);
      filters.on('click', 'button', function () {
        var val = $(this).attr('data-filter');
        isotope.isotope({
          filter: val
        });
        filters.find('.active').removeClass('active');
        $(this).addClass('active');
      });

    }
    initGallery();
  });
});

function initGallery() {
  $('.popup-gallery').each(function () {
    $(this).find('.grid-item:visible').find('a.gallery-img').magnificPopup({
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
      },
    });
  });
}